import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ArtworkState, DimensionsPendingState, DimensionsState} from "../../definitions/types";

export type AddToCartType = {
    artwork?: ArtworkState,
    artworkNotesPending: boolean,
    artworkUploadPending: boolean,
    promotionCode?: string,
    designServiceId?: number,
    dimensions: DimensionsState,
    dimensionsPending: DimensionsPendingState,
    quantity: number
    displayQuantity: number,
    quantityPending: boolean,
    warrantyId?: number
}

// @ts-ignore
const promotionCode = window.viewModel.promotionCode;

export const name = "addToCart";

const addToCartSlice = createSlice({
    name: name,
    initialState: {
        value: {
            artworkNotesPending: false,
            artworkUploadPending: false,
            quantity: 1,
            displayQuantity: 1,
            quantityPending: false,
            promotionCode,
            dimensions: {} as DimensionsState,
            dimensionsPending: {} as DimensionsPendingState,
        } as AddToCartType
    },
    reducers: {
        set: (state, action: PayloadAction<AddToCartType>) => {
            state.value = action.payload;
        },
        setArtwork: (state, action: PayloadAction<ArtworkState | undefined>) => {
            // Use this syntax to prevent race conditions, due to two consumers updating this state
            state.value.artwork = { ...state.value.artwork, ...action.payload };
        },
        clearArtworkFile: (state) => {
            // Separate clean action to clean the artwork but not the notes
            state.value.artwork = { ...state.value.artwork, name: undefined, id: undefined, file: undefined, preview: undefined};
        },
        clearArtworkNotes: (state) => {
            // Separate clean action to clean the artwork notes, but not the artwork file
            state.value.artwork = { ...state.value.artwork, notes: undefined };
        },
        setArtworkUploadPending: (state, action: PayloadAction<boolean>) => {
            state.value.artworkUploadPending = action.payload;
        },
        setArtworkNotesPending: (state, action: PayloadAction<boolean>) => {
            state.value.artworkNotesPending = action.payload;
        },
        setPromotionCode: (state, action: PayloadAction<string>) => {
            state.value.promotionCode = action.payload;
        },
        setDesignService: (state, action: PayloadAction<number | undefined>) => {
            state.value.designServiceId = action.payload;
        },
        clearDesignService: (state) => {
            state.value.designServiceId = undefined;
        },
        setDimensions: (state, action: PayloadAction<DimensionsState>) => {
            state.value.dimensions = { ...state.value.dimensions, ...action.payload };
        },
        clearDimensions: (state) => {
            state.value.dimensions = {} as DimensionsState;
        },
        setPendingDimensions: (state, action: PayloadAction<DimensionsPendingState>) => {
            state.value.dimensionsPending = { ...state.value.dimensionsPending, ...action.payload };
        },
        setQuantity: (state, action: PayloadAction<number>) => {
            state.value.quantity = action.payload;
        },
        setDisplayQuantity: (state, action: PayloadAction<number>) => {
            state.value.displayQuantity = action.payload;
        },
        setPendingQuantity: (state, action: PayloadAction<boolean>) => {
            state.value.quantityPending = action.payload;
        },
        setWarranty: (state, action: PayloadAction<number | undefined>) => {
            state.value.warrantyId = action.payload;
        },
        clearWarranty: (state) => {
            state.value.warrantyId = undefined;
        },
    }
});

export const {
    set: setAddToCart,
    setQuantity,
    setDisplayQuantity,
    setPendingQuantity,
    setWarranty,
    setDesignService,
    setDimensions,
    setPendingDimensions,
    setArtwork,
    setArtworkUploadPending,
    setArtworkNotesPending,
    setPromotionCode,
    clearArtworkFile,
    clearArtworkNotes,
    clearWarranty,
    clearDesignService,
    clearDimensions,
} = addToCartSlice.actions;
export default addToCartSlice.reducer;